import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerSingle = ({ formik, fieldName }) => {
    const today = new Date();

    return (
        <div className="date-picker-container">
            <DatePicker
                selected={formik.values[fieldName]}
                onChange={(date) => formik.setFieldValue(fieldName, date)}
                // maxDate={today} // Restrict to past dates
                placeholderText="Select Schedule Date"
                className="date-picker-input"
            />
            <div className="calendar-icon">
                <i className="bx bx-calendar"></i>
            </div>
        </div>
    );
};

export default DatePickerSingle;
